<app-login *ngIf="!user"></app-login>
<app-side-menu *ngIf="user" [user]="user"></app-side-menu>
